import { withHTMLComponent } from '@updater-legacy/components/custom-element';

const tpl = `
  <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10">
    <path fill="none" fill-rule="evenodd" stroke="#236087" stroke-linecap="square" stroke-linejoin="round" d="M.5 4.9l3.214 3L9.5 2.5"/>
  </svg>
`;

class Checkmark extends withHTMLComponent('', tpl)() {}

customElements.define('upd-home-security-checkmark', Checkmark);
